import React from 'react';
import { Img } from 'react-image';

const PositionUnderReviewState = () => {
	return (
		<div className="flex flex-col items-center justify-center">
			<div className="px-8">
				<div className="flex justify-center">
					<Img
						loading="lazy"
						src="/assets/noApplicationsEmptyState.svg"
						alt="noApplicationsEmptyState"
						width="160"
						height="160"
					/>
				</div>

				<div className="text-center mt-4 text-base font-medium">Position is currently under review.</div>
				<div className="text-center mt-2 text-sm font-normal text-[#555770] dark:text-[#C7C9D9] max-w-[350px]">
					We'll notify you once it's live for candidate recommendations.
				</div>
			</div>
		</div>
	);
};

export default PositionUnderReviewState;
